import http from "../../utils/httpClient";

class categoryService {
  createOrUpdateCategory = async (data) => {
    return await http.post("/api/Category", data);
  };

  authenticateUser = async () => {
    return (
      (await localStorage.getItem("x-access-token")) &&
      localStorage.getItem("x-access-token-expiration") > Date.now()
    );
  };

  deauthenticateUser = async () => {
    (await localStorage.removeItem("x-access-token")) &&
      localStorage.getItem("x-access-token-expiration");
    window.location = window.location.origin + "/";
  };

  saveToken = async (token) => {
    (await localStorage.setItem("x-access-token", token)) &&
      localStorage.getItem("x-access-token-expiration");
  };

  getToken = (async) => {
    return localStorage.getItem("x-access-token");
  };

  retrieveToken = (async) => {
    return this.getToken();
  };

  retriveEmployeeId = (async) => {
    return this.getEmployeeId();
  };

  retriveRoleId = (async) => {
    return this.getRoleId();
  };

  getCategory = async (query) => {
    return await http.get("/api/Category/GetCategory", { params: query });
  };

  getCategoryList = async (query) => {
    return await http.get("/api/Category/GetCategory", { params: query });
  };

  getCategoryById = async (searchBy) => {
    return await http.get("/api/Category/" + searchBy);
  };

  getEmployeeId = (async) => {
    return localStorage.getItem("x-access-employeeId");
  };

  getRoleId = (async) => {
    return localStorage.getItem("x-access-roleId");
  };
}

export default new categoryService();
